/**
 * Logout after inactivity component
 */

//  Generic imports
import { useEffect, useState } from "react";
import { useMsal } from "@azure/msal-react";

const IdleLogout = () => {
  const [lastActivityTime, setLastActivityTime] = useState(Date.now());
  const { instance } = useMsal();
  const idleTimeoutTime = process.env.REACT_APP_IDLE_TIMEOUT_TIME;
  const idleTimeoutCheckTime = process.env.REACT_APP_IDLE_TIMEOUT_CHECK_TIME;

  useEffect(() => {
    // Function to handle user activity
    const handleActivity = () => {
      setLastActivityTime(Date.now());
    };

    // Event listeners to track user activity
    document.addEventListener("mousemove", handleActivity);
    document.addEventListener("keydown", handleActivity);

    // Clear event listeners on unmount
    return () => {
      document.removeEventListener("mousemove", handleActivity);
      document.removeEventListener("keydown", handleActivity);
    };
  }, []);

  useEffect(() => {
    // Timer for checking inactivity
    const checkInactivityTimer = setTimeout(() => {
      const currentTime = Date.now();
      const inactiveTime = currentTime - lastActivityTime;
      const pathname = window.location.pathname;
      if ((inactiveTime > parseInt(idleTimeoutTime)) && (pathname !== "/LogOut")) {
        logoutUser();
      }
    }, parseInt(idleTimeoutCheckTime)); // Check  for inactivity

    // Clear the timer on activity
    const clearTimer = () => clearTimeout(checkInactivityTimer);

    document.addEventListener("mousemove", clearTimer);
    document.addEventListener("keydown", clearTimer);

    // Clear the timer on component unmount
    return () => {
      document.removeEventListener("mousemove", clearTimer);
      document.removeEventListener("keydown", clearTimer);
      clearTimeout(checkInactivityTimer);
    };
    //  eslint-disable-next-line
  }, [lastActivityTime]);

  const logoutUser = () => {
    const logoutRequest = {
      account: instance.getActiveAccount(),
      postLogoutRedirectUri: "/LogOut",
    };
    instance.logout(logoutRequest);
  };
};

export default IdleLogout;
